import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`HostJane follows the IHRA Working Definition on both Antisemitism, and on Holocaust Denial and Distortion, to say no to all Jew-Hatred online.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      